export default ({ onClick = undefined }) => (
  <svg
    onClick={onClick}
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16 8C16 12.4182 12.4182 16 8 16C3.58178 16 0 12.4182 0 8C0 3.58178 3.58178 0 8 0C12.4182 0 16 3.58178 16 8Z"
      fill="#FFCC4D"
    />
    <path
      d="M7.9992 9.71015C6.68098 9.71015 5.80587 9.55637 4.72409 9.34615C4.47654 9.29904 3.99609 9.34615 3.99609 10.0741C3.99609 11.5297 5.66854 13.3493 7.9992 13.3493C10.3299 13.3493 12.0023 11.5297 12.0023 10.0741C12.0023 9.34615 11.5214 9.29859 11.2743 9.34615C10.1925 9.55637 9.31787 9.71015 7.9992 9.71015Z"
      fill="#664500"
    />
    <path
      d="M7.40082 1.45848C7.01904 0.378033 5.8346 -0.189078 4.75371 0.19181C4.09771 0.422922 3.63326 0.952255 3.45238 1.57137C2.92304 1.20292 2.22971 1.08248 1.5746 1.31359C0.494598 1.69492 -0.0734019 2.88025 0.308376 3.9607C0.362598 4.11359 0.434598 4.25537 0.518154 4.38648C1.38526 5.97848 3.8906 7.09759 5.40749 7.11137C6.57949 6.14825 7.82793 3.7047 7.50438 1.92159C7.48749 1.76692 7.45415 1.61137 7.40082 1.45848V1.45848ZM8.60082 1.45848C8.9826 0.378033 10.1675 -0.189078 11.2479 0.19181C11.9039 0.422922 12.3684 0.952255 12.5497 1.57137C13.079 1.20292 13.7724 1.08248 14.4275 1.31359C15.5075 1.69492 16.075 2.88025 15.6942 3.9607C15.6395 4.11359 15.5679 4.25537 15.4839 4.38648C14.6168 5.97848 12.1115 7.09759 10.5942 7.11137C9.42215 6.14825 8.17415 3.7047 8.49771 1.92159C8.51415 1.76692 8.54749 1.61137 8.60082 1.45848V1.45848Z"
      fill="#DD2E44"
    />
  </svg>
);
